export enum Unit {
  BYTES = "B",
  SECONDS = "s",
  PER_SECOND = "/s", // should not be used with D3 si tick formatting, to avoid confusion. e.g. 900m/s, instead of 0.9/s
  BYTES_PER_SECOND = "B/s",
  PERCENT = "%",
}
